<template>
  <div>
    <slot></slot>
    <div :id="configObj.mapId" class="map-box"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import L from 'leaflet'
import global from '../../assets/js/global.js'
// import { EventBus } from "../../event-bus"
export default {
  name: 'rg-map-basic',
  props: {
    configObj: {
      type: Object,
      default() {
        return {
          mapId: 'map'
        }
      }
    }
  },
  watch: {
    configObj(val) {
      if (val) {
        this.initMap()
      }
    }
  },
  data() {
    return {
      osm: null,
      mybounds: null
    }
  },
  mounted() {
    // EventBus.$emit("zxp-map", 567)
  },
  methods: {
    initMap() {
      this.osm = L.tileLayer(this.configObj.osmUrl, {
        minZoom: this.configObj.min,
        maxZoom: this.configObj.max
      })
      this.mybounds = L.latLngBounds(this.configObj.southWest, this.configObj.northEast)
      const defaultZoom = this.configObj.defaultZoom || this.configObj.min
      // 初始化地图  状态选项
      this.$nextTick(() => {
        Vue.prototype.$rgMap = L.map(this.configObj.mapId, {
          preferCanvas: true,
          attributionControl: false,
          zoomControl: false
        })
          // 初始化设置中心点、初始缩放级别
          .setView(this.configObj.mapCenter, defaultZoom)
          .addLayer(this.osm)
          // 最大可视范围设置
          .setMaxBounds(this.mybounds)
        // EventBus.$emit("mapReady", this.map)
        Vue.prototype.$rgMap.doubleClickZoom.disable() // 禁止双击放大
        this.$emit('mapReady', Vue.prototype.$rgMap)
        Vue.prototype.global = global
        Vue.prototype.global.configObj = this.configObj
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.map-box {
  width: 100%;
  height: 100vh;
  margin: 0;
}
</style>
